/**
 * @description 繳費方式 (enum)
 */
export enum PaymentMethodsEnum {
  /** 信用卡 */
  CreditCard = 'H',
  /** 帳戶轉帳 */
  Transfer = 'K',
  /** 自動轉帳 */
  Auto = 'A'
}
